module.exports = __webpack_public_path__ + "static/media/KZ.167cd7e7.png";